import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { QuickLinksComponent } from './quick-links.component';
import { DlsButtonModule } from '@zelis/dls/button';
import { MatMenuModule } from '@angular/material/menu';
import { DlsIconModule } from '@zelis/dls/icons';

@NgModule({
  imports: [
    CommonModule,
    PageContainerModule,
    TranslateModule,
    RouterModule,
    MatMenuModule,
    DlsButtonModule,
    DlsIconModule,
  ],
  declarations: [QuickLinksComponent],
  exports: [QuickLinksComponent],
})
export class QuickLinksModule {}
